module.exports = require("core-js/modules/es.symbol.async-iterator.js");